import ProductPage from "@/pages/product/product-page";
import ProductDetailPage from "@/pages/product/product-detail-page";
import ProductAttributesPage from "@/pages/product-attributes";
import CreateProductPage from "@/pages/product/create-product-page";
import EditProductPage from "@/pages/product/edit-product-page";
import VariantListPage from "@/pages/product/variant-list-page";
import { route } from "../utils";
import { RouteType } from "../types";

// Define routes with semantic names - single source of truth
export const productRoutes: Record<string, RouteType> = {
  list: route("/products", ProductPage),
  variants: route("/product-variants", VariantListPage),
  new: route("/products/new", CreateProductPage),
  attributes: route("/product-attributes", ProductAttributesPage),
  edit: route("/products/:id/edit", EditProductPage),
  detail: route("/products/:id", ProductDetailPage),
};
